import React, { useEffect, useRef } from "react";
import "./myprofile.scss";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Chart from "react-apexcharts";
import { useWeb3React } from "@web3-react/core";
import { bsc, flame } from "viem/chains";
import getNodeUrl from "../../utils/getRpcUrl";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Balance from "../../hooks/dataFetcher/BalanceOf";
import QRCode from "react-qr-code";
import useWeb3 from "../../hooks/useWeb3";
import {
  createWalletClient,
  custom,
  encodeFunctionData,
  http as viemHttp,
} from "viem";
import {
  createMeeClient,
  toMultichainNexusAccount,
} from "@biconomy/abstractjs";
import { useTransfer } from "../../hooks/dataFetcher/transfer";
import { wait } from "@testing-library/user-event/dist/cjs/utils/index.js";
import useWithdrawalAmountHook from "../../hooks/dataFetcher/withdrawAmount";
import axios from "axios";
import Loader from "../../hooks/loader";
import { useCheckAllowance } from "../../hooks/dataSender/Allowance";
import { useApprove } from "../../hooks/dataSender/Approval";
import { toast } from "react-toastify";
import useSignature from "../../hooks/userSign";
import { BrowserProvider, ethers } from "ethers";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { utils } from "web3";
import showToast from "../../hooks/showToast";
import {
  userPrivateKey,
  userProfileState,
  userSmartAccount,
  userSmartAccountClient,
} from "../../components/recoilAtom";
import { CRASH_GAME_CONTRACT } from "../../utils/Enviroment";
import WithDrawModel from "../withDrawModel";
import DepositModel from "../depositeModel";
import backendClient from "../../utils/backendClient";
import { callCrashGameGraphQLQuery } from "../../utils/axiosClient";
import { data } from "jquery";
import useAuth from "../../hooks/useAuth";

const Myprofile = () => {
  const { login, logout } = useAuth();
  const smartAccount = useRecoilValue(userSmartAccount);
  const userSmartClient = useRecoilValue(userSmartAccountClient);
  const setUserProfile = useSetRecoilState(userProfileState);
  const privatekeyy = useRecoilValue(userPrivateKey);

  const { userLibrary } = useSignature();
  const approvee = useApprove();
  const { checkAllowance } = useCheckAllowance();
  const web3 = useWeb3();
  const { BalanceHook } = Balance();
  const { withdrawalAmountTransaction } = useWithdrawalAmountHook();
  const { account } = useWeb3React();
  const chain = bsc;
  const RPC_URL = getNodeUrl();
  const [copy, setCopy] = useState(false);
  const [userBalance, setUserBalance] = useState(null);
  const [withdrawInput, setwithdrawInput] = useState(null);
  const [depositeInput, setDepositeInput] = useState(null);
  const [userBalanceExternal, setUserBalanceExternal] = useState(null);
  const [internalAccount, setInternalAccount] = useState(null);
  const [ethInternalBalance, setEthInternalBalance] = useState(null);
  const [ethExternalBalance, setEthEnternalBalance] = useState(null);
  const [ethPrice, setEthprice] = useState(null);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorBool, setErrorBool] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loaderText, setLoaderText] = useState({
    heading: "Loading",
    paragraph: "",
  });
  const [twitterLink, setTwitterLink] = useState("");
  const [telegramLink, setTelegramLink] = useState("");
  const [discordLink, setDiscordLink] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [playerTransactions, setPlayerTransactions] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [inputName, setInputName] = useState("");
  const [PnL, setPnl] = useState(0);
  const [betHistory, setBetHistory] = useState([]);
  const [latestBetHistory, setLatestBetHistory] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show4, setShow4] = useState(false);
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const [show5, setShow5] = useState(false);
  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);

  const transferFunds = useTransfer();
  const options = {
    chart: {
      type: "bar",
      stacked: false,
      toolbar: {
        show: false,
      },
      background: "transparent",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        borderRadius: 0,
        distributed: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "solid",
      colors: ["#F24CA2"],
    },
    xaxis: {
      categories: ["june 02", "june 09", "june 16", "june 23", "june 30"],
      labels: {
        style: {
          colors: ["#606367", "#606367", "#606367", "#606367", "#606367"],
          fontSize: "12px",
          fontWeight: 400,
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: false,
    },
    grid: {
      show: false,
    },
    tooltip: {
      theme: "dark",
      y: {
        formatter: (value) => `$${parseFloat(value).toLocaleString()}`,
      },
    },
  };

  const series = [
    {
      name: "Volume",
      data: [120000, 90000, 150000, 110000, 130000],
    },
  ];

  const internalAccountHandler = async () => {
    try {
      // const clientSigner = createWalletClient({
      //   chain,
      //   account: account,
      //   transport: custom(global?.window?.ethereum ?? ""),
      // });
      // const smartAccount = await toMultichainNexusAccount({
      //   signer: clientSigner,
      //   transports: [viemHttp(RPC_URL)],
      //   chains: [chain],
      // });

      // let internalAccount = smartAccount.addressOn(chain.id);

      // console.log(smartAccountAddress, "smartAccountAddress");

      const balance = await BalanceHook(smartAccount);
      const balance1 = await BalanceHook(account);
      setUserBalance(balance);
      setUserBalanceExternal(balance1);
      setInternalAccount(smartAccount);
      const balanceWei = await web3.eth.getBalance(account);
      const balanceEth = web3.utils.fromWei(balanceWei, "ether");

      const balanceWei1 = await web3.eth.getBalance(smartAccount);
      const balanceEth1 = web3.utils.fromWei(balanceWei1, "ether");
      setEthInternalBalance(balanceEth1);
      setEthEnternalBalance(balanceEth);
      let balace = await axios.get(
        "https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD"
      );
      setEthprice(balace.data.USD);
    } catch (err) {
      console.log(err, "err");
    }
  };

  useEffect(() => {
    if (web3 && smartAccount) {
      internalAccountHandler();
    }
  }, [smartAccount, web3]);

  const CallCopy = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, [3000]);
  };

  // console.log(smartAccount, "callMeWallet");

  //bakend integration functions start here
  const fetchUserProfile = async () => {
    const response = await backendClient.get("/users/user-profile");
    return response.data;
  };
  const fetchUserTransactions = async () => {
    const response = await backendClient.get(
      "/transactions/transactions-history?limit=1000&offset=1"
    );
    return response.data;
  };
  const loadUserProfile = async () => {
    try {
      const data = await fetchUserProfile();
      setProfileData(data?.data);
      setInputName(data?.data?.name || "");
      setTwitterLink(data?.data?.twitterLink || "");
      setDiscordLink(data?.data?.discordLink || "");
      setTelegramLink(data?.data?.telegramLink || "");

      setPreview(data?.data?.profilePic || "");
      setUserProfile({
        name: data?.data?.name || "",
        profilePic: data?.data?.profilePic || "",
      });
    } catch (error) {
      console.error("Failed to load profile:", error);
    } finally {
      setLoading(false);
    }
  };
  const getProfile = async () => {
    try {
      const data = await fetchUserProfile();
      setProfileData(data?.data);
    } catch (error) {
      console.error("Failed to fetch profile:", error);
    } finally {
      setLoading(false);
    }
  };
  const getPlayerTransactions = async () => {
    try {
      const data = await fetchUserTransactions();
      setPlayerTransactions(data?.data?.transactions);
    } catch (error) {
      console.error("Failed to fetch profile:", error);
    } finally {
      setLoading(false);
    }
  };
  // const fetchOwnerBetHistory = async () => {
  //   const resolvedBetsQuery = `
  //     query GetResolvedBets {
  //       betResolveds(orderDirection: desc, orderBy: blockTimestamp, where: { player: "${smartAccount}" }) {
  //         transactionHash
  //         amount
  //         random
  //         payout
  //         blockTimestamp
  //         won
  //       }
  //     }
  //   `;

  //   const placedBetsQuery = `
  //     query GetPlacedBets {
  //       betPlaceds(where: { player: "${smartAccount}" }) {
  //         amount
  //       }
  //     }
  //   `;

  //   const crashBetResolvedsQuery = `
  //     query GetCrashBetResolved {
  //       crashBetResolveds(where: { player: "${smartAccount}" }) {
  //         amount
  //         payout
  //       }
  //     }
  //   `;

  //   try {
  //     // Fetch all queries in parallel
  //     const [resolvedData, placedData, crashResolvedData] = await Promise.all([
  //       callCrashGameGraphQLQuery(resolvedBetsQuery),
  //       callCrashGameGraphQLQuery(placedBetsQuery),
  //       callCrashGameGraphQLQuery(crashBetResolvedsQuery),
  //     ]);

  //     const resolvedBets = resolvedData?.betResolveds || [];
  //     const placedBets = placedData?.betPlaceds || [];
  //     const crashBets = crashResolvedData?.crashBetResolveds || [];

  //     setBetHistory(resolvedBets);
  //     setLatestBetHistory(resolvedBets[0]);

  //     // ✅ Sum payout from resolvedBets
  //     const totalPayoutFromResolved = resolvedBets.reduce((sum, bet) => {
  //       return (
  //         sum +
  //         parseFloat(web3.utils.fromWei(String(bet?.payout || "0"), "mwei"))
  //       );
  //     }, 0);

  //     // ✅ Sum payout from crashBetResolveds
  //     const totalPayoutFromCrash = crashBets.reduce((sum, bet) => {
  //       return (
  //         sum +
  //         parseFloat(web3.utils.fromWei(String(bet?.payout || "0"), "mwei"))
  //       );
  //     }, 0);

  //     // ✅ Sum amount from placedBets
  //     const totalAmountFromPlaced = placedBets.reduce((sum, bet) => {
  //       return (
  //         sum +
  //         parseFloat(web3.utils.fromWei(String(bet?.amount || "0"), "mwei"))
  //       );
  //     }, 0);

  //     // ✅ Sum amount from crashBetResolveds
  //     const totalAmountFromCrash = crashBets.reduce((sum, bet) => {
  //       return (
  //         sum +
  //         parseFloat(web3.utils.fromWei(String(bet?.amount || "0"), "mwei"))
  //       );
  //     }, 0);

  //     // ✅ Final Calculations
  //     const totalPayout = totalPayoutFromResolved + totalPayoutFromCrash;
  //     const totalAmount = totalAmountFromPlaced + totalAmountFromCrash;
  //     const netProfit = totalPayout - totalAmount;

  //     setPnl(netProfit);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Failed to fetch bet history:", error);
  //     setLoading(false);
  //   }
  // };
  const fetchOwnerBetHistory = async () => {
    const resolvedBetsQuery = `
      query GetResolvedBets {
        betResolveds(orderDirection: desc, orderBy: blockTimestamp, where: { player: "${smartAccount}" }) {
          transactionHash
          amount
          payout
          blockTimestamp
          won
        }
      }
    `;

    const placedBetsQuery = `
      query GetPlacedBets {
        betPlaceds(where: { player: "${smartAccount}" }) {
          amount
          transactionHash
        }
      }
    `;

    const crashBetResolvedsQuery = `
      query GetCrashBetResolved {
        crashBetResolveds(first: 10000,where: { player: "${smartAccount}" }) {
          amount
          payout
          transactionHash
        }
      }
    `;

    const crashBetPlacedsQuery = `
      query GetCrashBetPlaceds {
        crashBetPlaceds(first: 10000,where: { player: "${smartAccount}" }) {
          amount
          transactionHash
        }
      }
    `;

    try {
      const [resolvedData, placedData, crashResolvedData, crashPlacedData] =
        await Promise.all([
          callCrashGameGraphQLQuery(resolvedBetsQuery),
          callCrashGameGraphQLQuery(placedBetsQuery),
          callCrashGameGraphQLQuery(crashBetResolvedsQuery),
          callCrashGameGraphQLQuery(crashBetPlacedsQuery),
        ]);

      const resolvedBets = resolvedData?.betResolveds || [];
      const placedBets = placedData?.betPlaceds || [];
      const crashResolvedBets = crashResolvedData?.crashBetResolveds || [];
      const crashPlacedBets = crashPlacedData?.crashBetPlaceds || [];

      // 👉 Odds Game Calculations
      const totalAmountFromPlaced = placedBets.reduce((sum, bet) => {
        const amount = parseFloat(
          web3.utils.fromWei(bet?.amount || "0", "mwei")
        );
        return sum + amount;
      }, 0);

      const totalPayoutFromResolved = resolvedBets.reduce((sum, bet) => {
        const payout = parseFloat(
          web3.utils.fromWei(bet?.payout || "0", "mwei")
        );
        return sum + payout;
      }, 0);

      // 👉 Crash Game Calculations
      const totalAmountFromCrashPlaced = crashPlacedBets.reduce((sum, bet) => {
        const amount = parseFloat(
          web3.utils.fromWei(bet?.amount || "0", "mwei")
        );
        return sum + amount;
      }, 0);

      const totalPayoutFromCrashResolved = crashResolvedBets.reduce(
        (sum, bet) => {
          const payout = parseFloat(
            web3.utils.fromWei(bet?.payout || "0", "mwei")
          );
          return sum + payout;
        },
        0
      );

      const totalAmount = totalAmountFromPlaced + totalAmountFromCrashPlaced;
      const totalPayout =
        totalPayoutFromResolved + totalPayoutFromCrashResolved;
      const netProfit = totalPayout - totalAmount;

      // Set state (React)
      setBetHistory(resolvedBets);
      setLatestBetHistory(resolvedBets[0]);
      setPnl(netProfit);
      setLoading(false);
    } catch (error) {
      console.error("🚨 Failed to fetch bet history:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOwnerBetHistory();
    getProfile();
    getPlayerTransactions();
    loadUserProfile();
  }, [smartAccount]);

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setPreview(URL.createObjectURL(file));
  //     setSelectedFile(file);
  //   }
  // };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png"];

      if (!validTypes.includes(file.type)) {
        showToast("error", "lease upload an image in JPEG or PNG format only.");

        e.target.value = null; // Clear invalid file
        return;
      }

      setPreview(URL.createObjectURL(file));
      setSelectedFile(file);
    }
  };

  const handleSaveChanges = async () => {
    if (isSaving) return; // Prevent double submit

    setLoading(true);
    setIsSaving(true);

    const updates = {};
    const imageChanged = !!selectedFile;
    const nameChanged = inputName && inputName !== profileData.name;
    const twitterChanged =
      twitterLink && twitterLink !== profileData.twitterLink;
    const telegramChanged =
      telegramLink && telegramLink !== profileData.telegramLink;
    const discordChanged =
      discordLink && discordLink !== profileData.discordLink;

    if (nameChanged) updates.name = inputName;
    if (twitterChanged) updates.twitterLink = twitterLink;
    if (telegramChanged) updates.telegramLink = telegramLink;
    if (discordChanged) updates.discordLink = discordLink;
    // updates.userSmartAddress =smartAccount;

    try {
      // 1. If image changed, upload it to /metadata/upload-image first
      if (imageChanged) {
        const formData = new FormData();
        formData.append("image", selectedFile); // ✅ field must be `image`

        const uploadResponse = await backendClient.post(
          "/metadata/upload-image",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        const imageUrl = uploadResponse?.data?.url;

        if (imageUrl) {
          updates.profilePic = imageUrl;
        } else {
          throw new Error(
            "Image upload failed or missing image URL in response"
          );
        }
      }

      // 2. If any updates, send them to backend
      if (Object.keys(updates).length > 0) {
        await backendClient.patch("/users/user-profile-update", updates);
      }

      // 3. Refresh profile and reset
      await loadUserProfile();
      handleClose();
    } catch (error) {
      console.error("Update failed:", error);

      const isLargeFile =
        error.message === "Network Error" || error.response?.status === 413;

      if (isLargeFile) {
        showToast(
          "error",
          "Image is too large. Please upload a file under 5MB."
        );
      } else {
        showToast("error", "Failed to update profile. Please try again.");
      }
    } finally {
      setIsSaving(false);
      setLoading(false);
    }
  };

  const handleRemoveImage = async () => {
    if (isSaving) return; // Prevent action during save

    setLoading(true);
    setIsSaving(true);

    try {
      // Call API to remove the profile picture
      await backendClient.patch("/users/remove-user-profile-pic");

      // Reset local state
      setPreview("");
      setSelectedFile(null);

      // Optionally reload profile data
      await loadUserProfile();
      showToast("success", "Profile picture removed successfully.");
    } catch (error) {
      console.error("Failed to remove profile picture:", error);
      showToast("error", "Failed to remove profile picture. Please try again.");
    } finally {
      setIsSaving(false);
      setLoading(false);
    }
  };

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(privatekeyy).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    });
  };

  const [copied1, setCopied1] = useState(false);
  const referralLink = `https://dev.tothemoon.co/${account}`;

  const handleCopy1 = () => {
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied1(true);
      setTimeout(() => setCopied1(false), 2000); // reset after 2s
    });
  };
  const disconnectWallet = async () => {
    const connectorId = window?.localStorage?.getItem("connectorId");
    await logout(connectorId);
    // localStorage.clear()
    localStorage.removeItem("connectorId");
    localStorage.removeItem("flag");
    localStorage.removeItem("signForAll");
    localStorage.removeItem("privateKey");
    localStorage.removeItem("placeBet");
    localStorage.removeItem("timeOfSign");
    localStorage.removeItem("sign");
    localStorage.removeItem("addrSign");
    // window.location.reload("/");
    // window.location.assign("/");

    Object.keys(localStorage).forEach((key) => {
      if (
        key.startsWith("wc@") ||
        key.startsWith("walletconnect") ||
        key.startsWith("WALLETCONNECT") ||
        key.includes("walletconnect") ||
        key.startsWith("wc_") ||
        key.startsWith("wcm_") // WalletConnect Modal
      ) {
        localStorage.removeItem(key);
      }
    });

    // Also clear sessionStorage items (WalletConnect sometimes uses this too)
    Object.keys(sessionStorage).forEach((key) => {
      if (
        key.startsWith("wc@") ||
        key.startsWith("walletconnect") ||
        key.startsWith("WALLETCONNECT") ||
        key.includes("walletconnect") ||
        key.startsWith("wc_") ||
        key.startsWith("wcm_")
      ) {
        sessionStorage.removeItem(key);
      }
    });

    // history.push("/");
  };
  return (
    <>
      <DepositModel
        show5={show5}
        handleClose5={handleClose5}
        internalAccount={internalAccount}
        userBalanceExternal={userBalanceExternal}
        ethExternalBalance={ethExternalBalance}
        onTransactionUpdate={getPlayerTransactions}
        bnbPrice={ethPrice}
        setShow5={setShow5}
      />
      <WithDrawModel
        show1={show1}
        handleClose1={handleClose1}
        userBalance={userBalance}
        ethInternalBalance={ethInternalBalance}
        onTransactionUpdate={getPlayerTransactions}
        bnbPrice={ethPrice}
      />
      <DepositModel />
      {loading && <Loader text={loaderText} />}
      <div className="custom-container">
        <section className="myprofile">
          <div className="upperbox">
            <div className="parentupperbox">
              <div className="left">
                <div className="innerleft">
                  <div className="profileimage">
                    <img
                      src={
                        profileData.profilePic
                          ? profileData.profilePic.replace(
                              "https://media-luckify.s3.us-west-2.amazonaws.com",
                              "https://d1o0gghweg2hi9.cloudfront.net"
                            )
                          : "image-unavailable.png"
                      }
                      alt="img"
                      className="img-fluid innerimg"
                    />
                  </div>
                </div>
                <div className="innerright">
                  <h6 className="heading">
                    {" "}
                    {profileData?.name || "Player Name"}
                  </h6>
                  <p className="parainner">
                    <span>
                      {internalAccount?.substring(0, 6)}...
                      {internalAccount?.substring(internalAccount?.length - 6)}
                      <CopyToClipboard
                        text={internalAccount}
                        onCopy={() => CallCopy()}
                      >
                        {copy ? (
                          <h6 className="copied">copied</h6>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            cursor="pointer"
                          >
                            <g clip-path="url(#clip0_758_16337)">
                              <path
                                d="M10 4H5C4.44772 4 4 4.44772 4 5V10C4 10.5523 4.44772 11 5 11H10C10.5523 11 11 10.5523 11 10V5C11 4.44772 10.5523 4 10 4Z"
                                stroke="#F24CA2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M2 8C1.45 8 1 7.55 1 7V2C1 1.45 1.45 1 2 1H7C7.55 1 8 1.45 8 2"
                                stroke="#F24CA2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_758_16337">
                                <rect width="12" height="12" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        )}
                      </CopyToClipboard>
                    </span>
                    {/* <button onClick={handleShow2} className="viewbtn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1503_8036)">
                          <path
                            d="M1.5098 10.1581C1.29099 10.3768 1.16803 10.6735 1.16797 10.9829V12.2499C1.16797 12.4046 1.22943 12.553 1.33882 12.6624C1.44822 12.7718 1.59659 12.8333 1.7513 12.8333H3.5013C3.65601 12.8333 3.80438 12.7718 3.91378 12.6624C4.02318 12.553 4.08464 12.4046 4.08464 12.2499V11.6666C4.08464 11.5119 4.14609 11.3635 4.25549 11.2541C4.36489 11.1447 4.51326 11.0833 4.66797 11.0833H5.2513C5.40601 11.0833 5.55439 11.0218 5.66378 10.9124C5.77318 10.803 5.83464 10.6546 5.83464 10.4999V9.9166C5.83464 9.76189 5.89609 9.61351 6.00549 9.50412C6.11489 9.39472 6.26326 9.33326 6.41797 9.33326H6.5183C6.8277 9.3332 7.12439 9.21024 7.34314 8.99143L7.81797 8.5166C8.62871 8.79902 9.51129 8.79794 10.3213 8.51354C11.1314 8.22914 11.8209 7.67825 12.2772 6.951C12.7334 6.22376 12.9294 5.3632 12.833 4.51011C12.7365 3.65702 12.3535 2.86191 11.7464 2.25485C11.1393 1.64778 10.3442 1.2647 9.49112 1.16828C8.63804 1.07186 7.77748 1.2678 7.05023 1.72405C6.32298 2.18031 5.7721 2.86986 5.4877 3.6799C5.2033 4.48994 5.20222 5.37253 5.48464 6.18326L1.5098 10.1581Z"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.6237 4.66683C9.78478 4.66683 9.91536 4.53625 9.91536 4.37516C9.91536 4.21408 9.78478 4.0835 9.6237 4.0835C9.46261 4.0835 9.33203 4.21408 9.33203 4.37516C9.33203 4.53625 9.46261 4.66683 9.6237 4.66683Z"
                            fill="#fff"
                            stroke="#fff"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1503_8036">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      View Private Key
                    </button> */}
                  </p>
                  <div className="socialicons">
                    <div className="iconsmain">
                      <a
                        href={twitterLink || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="iconsmain"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_758_16342)">
                            <path
                              d="M8.915 1.76074H10.4587L7.08613 5.61541L11.0537 10.8607H7.94713L5.51393 7.67947L2.72979 10.8607H1.18513L4.79246 6.73774L0.986328 1.76074H4.1718L6.3712 4.66854L8.915 1.76074ZM8.3732 9.93674H9.2286L3.707 2.63621H2.78906L8.3732 9.93674Z"
                              fill="#BCC1CC"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_758_16342">
                              <rect
                                width="11.2"
                                height="11.2"
                                fill="white"
                                transform="translate(0.400391 0.710938)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>
                    <div className="iconsmain">
                      <a
                        href={profileData.telegramLink || ""}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="iconsmain"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="9"
                          viewBox="0 0 10 9"
                          fill="none"
                        >
                          <path
                            d="M7.13561 3.10484C7.42186 2.81008 7.70603 2.1223 6.51334 2.95746C5.39921 3.74708 4.27751 4.52532 3.1484 5.29208C2.97647 5.37212 2.79059 5.41559 2.60194 5.41981C2.41329 5.42403 2.22576 5.38894 2.05061 5.31664C1.33499 5.09557 0.499592 4.80081 0.499592 4.80081C0.499592 4.80081 -0.0708257 4.43182 0.905625 4.0388C0.905625 4.0388 5.03389 2.29425 6.46563 1.67962C7.01427 1.43399 8.87539 0.647954 8.87539 0.647954C8.87539 0.647954 9.73464 0.30353 9.66308 1.13922C9.63923 1.48311 9.4484 2.6878 9.25757 3.98967C8.9708 5.83248 8.6607 7.84775 8.6607 7.84775C8.6607 7.84775 8.613 8.41272 8.20748 8.51097C7.77339 8.50339 7.35398 8.34789 7.01479 8.06883C6.91937 7.99514 5.22523 6.88924 4.60452 6.34884C4.54136 6.30479 4.49007 6.24504 4.45538 6.17508C4.42074 6.10513 4.40378 6.02728 4.40617 5.94878C4.40855 5.87028 4.43018 5.79371 4.46902 5.7261C4.50786 5.65855 4.56267 5.60216 4.62837 5.56228C5.47974 4.76017 6.31561 3.94087 7.13561 3.10484Z"
                            fill="#BCC1CC"
                          />
                        </svg>
                      </a>
                    </div>
                    <div className="iconsmain">
                      <a
                        href={discordLink || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="iconsmain"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M4.73537 10.9436C7.51642 12.029 9.88309 12.2404 12.565 10.551C12.5454 10.5805 12.0148 11.3665 10.6197 11.7693C10.9145 12.1721 11.3173 12.6338 11.3173 12.6338C12.2113 12.6338 13.0857 12.3784 13.8422 11.8872C14.4317 11.4942 14.7657 10.8163 14.6969 10.1089C14.579 8.90049 14.2941 7.72154 13.852 6.59174C13.292 5.11807 11.9461 4.0963 10.384 3.94892C10.2464 3.93909 10.1482 3.93909 10.0892 3.93909L9.93206 4.09627C11.7299 4.60715 12.624 5.40294 12.6436 5.43243C9.88291 4.03733 6.62117 4.0177 3.8408 5.37348C3.8408 5.37348 4.72502 4.49909 6.68009 4.03733L6.5622 3.91943C6.35587 3.91943 6.15938 3.93909 5.95308 3.96855C4.50886 4.21416 3.30046 5.20644 2.77975 6.57205C2.32781 7.751 2.03308 8.98889 1.92502 10.2464C1.86607 10.9145 2.18046 11.5728 2.73063 11.9559C3.45764 12.4373 4.3222 12.6928 5.19659 12.6928C5.19659 12.6928 5.55026 12.231 5.90396 11.8184C4.57764 11.4254 4.0373 10.6394 4.02747 10.6099L4.27708 10.7374C4.42629 10.8136 4.57927 10.8827 4.73537 10.9436ZM6.2773 10.0893C5.63869 10.0696 5.13764 9.52926 5.1573 8.88083C5.17696 8.27171 5.66818 7.78049 6.2773 7.76083C6.9159 7.78049 7.41696 8.32083 7.3973 8.96926C7.36781 9.57841 6.88642 10.0696 6.2773 10.0893ZM10.2857 10.0893C9.6471 10.0696 9.14604 9.52926 9.1657 8.88083C9.18536 8.27171 9.67659 7.78049 10.2857 7.76083C10.9243 7.78049 11.4254 8.32083 11.4057 8.96926C11.3861 9.57841 10.8948 10.0696 10.2857 10.0893Z"
                            fill="#BCC1CC"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="right">
                {account && (
                  <>
                    <button className="edit" onClick={handleShow}>
                      Edit Profile
                    </button>
                    <button
                      className="disconnectbtn d-none"
                      onClick={disconnectWallet}
                    >
                      Disconnect
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="portfolioparent">
            <div className="firstbox">
              <h6>Portfolio</h6>
              <h4 className="amountpara">
                ${(+userBalance).toFixed(4)}
                {/* <span className="grey">.99</span> */}
              </h4>
              <div className="mainspans">
                <div className="innerspan">
                  <div className="tokenimg">
                    <img
                      src="/assets/playassets/usdc.svg"
                      alt="innertokenimg"
                      className="innertokenimg"
                    />
                    <img
                      src="/assets/playassets/base.svg"
                      alt="baseimg"
                      className="baseimg"
                    />
                  </div>
                  <p className="tokenname">
                    {" "}
                    {Number(userBalance).toLocaleString(undefined, {
                      minimumFractionDigits: 4,
                      maximumFractionDigits: 4,
                    })}
                  </p>{" "}
                  <p className="tokenname">USDC</p>
                </div>
              </div>
              <div className="lastbutton">
                <button className="deposit" onClick={handleShow5}>
                  Deposit
                </button>
                <button className="withdraw" onClick={handleShow1}>
                  Withdraw
                </button>
              </div>
            </div>
            <div className="firstbox">
              <div className="parentmain">
                <div className="right">
                  <h6> Profit / Loss</h6>
                  <h6
                    className="innerhead"
                    style={{
                      color: PnL >= 0 ? "#09a85b" : "#ff3434",
                      fontSize: "18px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "100%",
                    }}
                  >
                    ${PnL?.toFixed(2)}
                  </h6>
                </div>
                {/* <div className="left">
                  <div className="weeks">
                    <p className="active">D</p>
                    <p>W</p>
                    <p>M</p>
                    <p>All</p>
                  </div>
                </div> */}
              </div>
              {/* <div
                className="chart-wrapper"
                style={{
                  background: "transparent",
                }}
              >
                <Chart
                  options={options}
                  series={series}
                  type="bar"
                  height={120}
                />
              </div> */}
            </div>
            <div className="firstbox">
              <h6 className="invitehead">Invite & Earn</h6>
              <p className="invitepara">
                You earn 1,000 points when a friend joins. They also earn 1,000
                points!
              </p>
              <div className="referalbox">
                <p className="referalpara">Referral Link</p>
                <a
                  href={referralLink}
                  className="referallink"
                  target="_blank"
                  rel="noreferrer"
                >
                  {referralLink}
                </a>
              </div>
              <button className="copybtn" onClick={handleCopy1}>
                {copied1 ? (
                  <>
                    Copied
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="9"
                      viewBox="0 0 11 9"
                      fill="none"
                    >
                      <path
                        d="M10.1663 1.5L3.74967 7.91667L0.833008 5"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </>
                ) : (
                  <>
                    COPY REFERRAL LINK
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_570_43)">
                        <path
                          d="M11.668 4.6665H5.83464C5.1903 4.6665 4.66797 5.18884 4.66797 5.83317V11.6665C4.66797 12.3108 5.1903 12.8332 5.83464 12.8332H11.668C12.3123 12.8332 12.8346 12.3108 12.8346 11.6665V5.83317C12.8346 5.18884 12.3123 4.6665 11.668 4.6665Z"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M2.33464 9.33317C1.69297 9.33317 1.16797 8.80817 1.16797 8.1665V2.33317C1.16797 1.6915 1.69297 1.1665 2.33464 1.1665H8.16797C8.80964 1.1665 9.33464 1.6915 9.33464 2.33317"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_570_43">
                          <rect width="14" height="14" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </>
                )}
              </button>
            </div>
          </div>
          {/* <div className='buttontemp mt-2 mb-2' onClick={handleShow4}>dsfhjdfcbgvnhjmk</div> */}
          <div className="tableboxmain">
            <h2 className="heading">History</h2>
            <div className="main-card">
              <div className="table-responsive">
                <table className="table">
                  <thead className="tblheadss">
                    <tr>
                      <th>Type</th>
                      <th>Date & Time</th>
                      <th>Amount </th>
                      <th>Tx Hash </th>
                    </tr>
                  </thead>
                  <tbody>
                    {playerTransactions.map((tx, index) => (
                      <tr key={tx._id || index}>
                        <td>
                          <p
                            className={
                              tx.transactionType === "deposit" ? "green" : "red"
                            }
                          >
                            {tx.transactionType
                              ? tx.transactionType.charAt(0).toUpperCase() +
                                tx.transactionType.slice(1)
                              : "N/A"}
                          </p>
                        </td>
                        <td>
                          <p className="gray">
                            {new Date(tx.createdAt).toLocaleString("en-US", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </p>
                        </td>
                        <td>
                          <p className="white">
                            $
                            {tx.amountUSD && parseFloat(tx.amountUSD) > 0
                              ? parseFloat(tx.amountUSD).toFixed(2)
                              : parseFloat(tx.amount).toFixed(2)}
                          </p>
                        </td>
                        <td>
                          <p className="hash">
                            {tx?.txHash
                              ? `${tx.txHash.slice(0, 6)}...${tx.txHash.slice(
                                  -3
                                )}`
                              : "N/A"}
                            {tx?.txHash && (
                              <a
                                href={`https://basescan.org/tx/${tx.txHash}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="innerlink"
                                style={{
                                  marginLeft: "6px",
                                  display: "inline-block",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="13"
                                  height="12"
                                  viewBox="0 0 13 12"
                                  fill="none"
                                >
                                  <path
                                    d="M11 6.5V9.5C11 9.76522 10.8946 10.0196 10.7071 10.2071C10.5196 10.3946 10.2652 10.5 10 10.5H3C2.73478 10.5 2.48043 10.3946 2.29289 10.2071C2.10536 10.0196 2 9.76522 2 9.5V2.5C2 2.23478 2.10536 1.98043 2.29289 1.79289C2.48043 1.60536 2.73478 1.5 3 1.5H6"
                                    stroke="#3E3F43"
                                    strokeWidth="1.04"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M11 1.5L6.5 6"
                                    stroke="#3E3F43"
                                    strokeWidth="1.04"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M8 1.5H11V4.5"
                                    stroke="#3E3F43"
                                    strokeWidth="1.04"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </a>
                            )}
                          </p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="parentboxmobilemain d-none">
              {playerTransactions.map((tx, index) => (
                <div className="innerboxmobilemain" key={tx._id || index}>
                  <div className="upper">
                    <div className="left">
                      <p>Type</p>
                      <h6
                        className={
                          tx.transactionType === "deposit" ? "green" : "red"
                        }
                      >
                        {tx.transactionType
                          ? tx.transactionType.charAt(0).toUpperCase() +
                            tx.transactionType.slice(1)
                          : "N/A"}
                      </h6>
                    </div>
                    <div className="left">
                      <p>Date & Time</p>
                      <h6 className="gray">
                        {new Date(tx.createdAt).toLocaleString("en-US", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </h6>
                    </div>
                  </div>

                  <div className="upper">
                    <div className="left">
                      <p>Amount</p>
                      <h6 className="white">
                        ${" "}
                        {tx.amountUSD && parseFloat(tx.amountUSD) > 0
                          ? parseFloat(tx.amountUSD).toFixed(2)
                          : parseFloat(tx.amount).toFixed(2)}
                      </h6>
                    </div>
                    <div className="left">
                      <p>Tx Hash</p>
                      <h6 className="hash">
                        {tx?.txHash
                          ? `${tx.txHash.slice(0, 6)}...${tx.txHash.slice(-3)}`
                          : "N/A"}{" "}
                        {tx?.txHash && (
                          <a
                            href={`https://basescan.org/tx/${tx.txHash}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              marginLeft: "6px",
                              display: "inline-block",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <path
                                d="M12.25 7.58333V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H6.41667"
                                stroke="#3E3F43"
                                strokeWidth="1.04"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12.25 1.75L7 7"
                                stroke="#3E3F43"
                                strokeWidth="1.04"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8.75 1.75H12.25V5.25"
                                stroke="#3E3F43"
                                strokeWidth="1.04"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                        )}
                      </h6>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <Modal className="editmodal" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mainupload">
            <div className="left">
              <div className="mainimg">
                <img
                  src={
                    preview
                      ? preview.replace(
                          "https://media-luckify.s3.us-west-2.amazonaws.com",
                          "https://d1o0gghweg2hi9.cloudfront.net"
                        )
                      : "image-unavailable.png"
                  }
                  alt="Profile Preview"
                  className="img-fluid innerimg"
                />
              </div>
            </div>

            <div className="right">
              <h6>Profile Image</h6>
              <p>
                We recommend to upload images in 400x400 resolution. Max 5 MB in
                JPEG or PNG format
              </p>
              <div className="twicebutton">
                <label htmlFor="upload" className="mainuploadddd">
                  <span className="innermainupload">CHANGE</span>
                </label>
                <input
                  type="file"
                  id="upload"
                  className="d-none"
                  accept="image/jpeg, image/png"
                  onChange={handleImageChange}
                  ref={fileInputRef}
                />
                <button className="remove" onClick={handleRemoveImage}>
                  Remove
                </button>
              </div>
            </div>
          </div>

          <div className="parentmaininput">
            <div className="innerinputmain">
              <p>Full Name</p>
              <input
                type="text"
                placeholder="Your name"
                value={inputName}
                onChange={(e) => setInputName(e.target.value)}
              />
            </div>

            <div className="innerinputmain">
              <p>Twitter Account</p>
              <input
                type="text"
                placeholder="https://x.com/yourprofile"
                value={twitterLink}
                onChange={(e) => setTwitterLink(e.target.value)}
              />
            </div>
            <div className="innerinputmain">
              <p>Telegram Account</p>
              <input
                type="text"
                placeholder="https://t.me/yourprofile"
                value={telegramLink}
                onChange={(e) => setTelegramLink(e.target.value)}
              />
            </div>

            <div className="innerinputmain">
              <p>Discord</p>
              <input
                type="text"
                placeholder="https://discord.com/yourprofile"
                value={discordLink}
                onChange={(e) => setDiscordLink(e.target.value)}
              />
            </div>
          </div>

          <div className="lastbuttons">
            <button className="cancle" onClick={handleClose}>
              Cancel
            </button>
            <button className="save" onClick={handleSaveChanges}>
              Save Changes
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="editmodal" show={show2} onHide={handleClose2} centered>
        <Modal.Header closeButton>
          <Modal.Title>Private Key</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="privatekeymain">
            <p className="innerkeypara">{privatekeyy}</p>
          </div>
          <div className="bottom-btns">
            <button className="closebtn" onClick={handleClose2}>
              Close
            </button>
            <button className="depositbtn" onClick={handleCopy}>
              {copied ? (
                "COPIED!!"
              ) : (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M11.1673 8.59992V11.3999C11.1673 13.7333 10.234 14.6666 7.90065 14.6666H5.10065C2.76732 14.6666 1.83398 13.7333 1.83398 11.3999V8.59992C1.83398 6.26658 2.76732 5.33325 5.10065 5.33325H7.90065C10.234 5.33325 11.1673 6.26658 11.1673 8.59992Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.1673 4.59992V7.39992C15.1673 9.73325 14.234 10.6666 11.9007 10.6666H11.1673V8.59992C11.1673 6.26658 10.234 5.33325 7.90065 5.33325H5.83398V4.59992C5.83398 2.26659 6.76732 1.33325 9.10065 1.33325H11.9007C14.234 1.33325 15.1673 2.26659 15.1673 4.59992Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>{" "}
                  COPY
                </>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="liquidity" show={show4} onHide={handleClose4} centered>
        <Modal.Header closeButton>
          <Modal.Title>Remove Liquidity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maincontentliquidity">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
              >
                <path
                  d="M25.9999 39H8.66658C7.51731 39 6.41511 38.5435 5.60246 37.7308C4.7898 36.9181 4.33325 35.8159 4.33325 34.6667V17.3333C4.33325 16.1841 4.7898 15.0819 5.60246 14.2692C6.41511 13.4565 7.51731 13 8.66658 13H43.3332C44.4825 13 45.5847 13.4565 46.3974 14.2692C47.21 15.0819 47.6666 16.1841 47.6666 17.3333V28.1667"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M39 26H39.0217"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M41.1667 34.6666V47.6666"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M47.6667 41.1666L41.1667 47.6666L34.6667 41.1666"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13 26H13.0217"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26.0001 30.3333C28.3933 30.3333 30.3334 28.3932 30.3334 26C30.3334 23.6067 28.3933 21.6666 26.0001 21.6666C23.6068 21.6666 21.6667 23.6067 21.6667 26C21.6667 28.3932 23.6068 30.3333 26.0001 30.3333Z"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <h6 className="heading">Fund Your Account</h6>
            <p className="para">
              Let's set up your wallet to trade on Luckify.
            </p>
          </div>
          <div className="lastbuttonsmain">
            <button className="skip">Skip for now</button>
            <button className="deposit">Deposit funds</button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Myprofile;
